// Invoice.js (or a separate file)
class InvoiceModel {
  constructor({ id, date, type, customerDetail, products }) {
    this.id = id;
    this.date = date;
    this.type = type;
    this.customerDetail = customerDetail;
    this.products = products;
  }
}

export default InvoiceModel;
